function staggerItems(itemClass, revealClass, staggerDelay, threshold) {
  const gridItems = document.querySelectorAll("." + itemClass);
  const observer = new IntersectionObserver(
    (entries, observer) => {
      let currentRow = null;
      let delay = 0;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const row = entry.target.parentElement;

          if (row !== currentRow) {
            currentRow = row;
            delay = 0;
          }
          setTimeout(() => {
            entry.target.classList.add(revealClass);
          }, delay);
          delay += staggerDelay; // Adjust delay time as needed
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: threshold }
  );

  gridItems.forEach((item) => {
    observer.observe(item);
  });
}

function revealItem(selector, threshold, offset) {
  const revealItems = document.querySelectorAll(`.${selector}`);
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: threshold, rootMargin: `0px 0px -${offset}px 0px` }
  );

  revealItems.forEach((item) => {
    observer.observe(item);
  });
}

function handleWait(element) {
  element.style.pointerEvents = "none";
  setTimeout(() => {
    element.style.pointerEvents = "auto";
    getCartItems();
  }, 500);
}

function handleWaitCart(element) {
  element.style.pointerEvents = "none";
  setTimeout(() => {
    element.style.pointerEvents = "auto";
    location.reload();
  }, 500);
}
